module.exports = __webpack_public_path__ + "img/products-buttons.1de3f54f.png";